import { useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Row, Button, Alert } from 'react-bootstrap';
import SignaturePad from 'react-signature-canvas';
import { FieldValidationErrorMsg } from '../../../sitel/demon/ui/atoms/form';
import SectionTitle from '../../../sitel/demon/ui/atoms/sectionTitle';
import { exemptionPageTitle } from '../../../services/exemptions';
import NukeRequest from '../../../components/atoms/nukeRequest';
import AknowledgementByExemption from './aknowledgementByExemption';
import { submitRequest } from '../../../services/api';
import './index.css';
import { DemonTile } from '../../../sitel/demon/ui/molecules';
import { getDateYYYYMMDD } from '../../../sitel/commons/utilities/dates';
import SubmitButton from '../../../sitel/demon/ui/atoms/buttons/SubmitButton';

export default function Step4Signature() {
  const [apiError, setApiError] = useState('');
  const { exemptionType, requestId } = useParams();
  const sigRef = useRef();
  const [signErrors, setSignErrors] = useState({ signature: null, signDate: null });
  const [isSubmitting, setIsSubmitting] =useState(false)

  const getImage = () => {
    if (sigRef.current.isEmpty()) {
      return false;
    }
    return sigRef.current.toDataURL('image/png');
  };

  //Once this goes to server. Exemption request is active.
  const handleSubmitExemption = () => {
    const newErrors = { signature: null, signDate: null };
    //validate signature filled
    const imgData = getImage();
    if (!imgData) {
      newErrors.signature = { message: 'Please sign the form' };
    }

    if (newErrors.signature) {
      setSignErrors(newErrors);
      return;
    }

    try {
      setIsSubmitting(true);
      submitRequest(
        requestId,
        imgData,
        getDateYYYYMMDD(new Date()),
        () => {
          window.location.href = '/oh-requests?flag=submitSuccess'; //Full refresh
        },
        (r) => {
          setIsSubmitting(false);
          window.scroll(0, 0);
          setApiError('An unexpected error has occured. Please try again later!');
          console.error('API ERROR (1)', r);
        }
      );
    } catch (error) {
      setIsSubmitting(false);
      window.scroll(0, 0);
      setApiError('An unexpected error has occured. Please try again later!');
      console.error('API ERROR (2):', error);
    }
  };

  return (
    <>
      {apiError ? (
        <Row>
          <Alert variant='danger'>{apiError}</Alert>
        </Row>
      ) : null}

      <SectionTitle>{exemptionPageTitle[exemptionType]}</SectionTitle>
      <DemonTile title='Acknowledgment'>
        <AknowledgementByExemption exemptionType={exemptionType} />
        <div className='card mt-5 mb-4 border-0'>
          <div className='row g-0 align-items-center'>
            <div className='col-md-2'>
              <div className='card-body'>
                <p className='card-text'>
                  Draw your <b>signature</b>
                  <br /> in the box.
                </p>
                <p className='card-text'>
                  <FieldValidationErrorMsg field='signature' errors={signErrors} />
                </p>
              </div>
            </div>
            <div className='col-md-10'>
              <div className='sig-containerx border bg-light rounded'>
                <SignaturePad ref={sigRef} canvasProps={{ className: 'sig' }} />
              </div>
            </div>
          </div>
          <Button onClick={() => sigRef.current.clear()} variant='link' className='position-absolute bottom-0 end-0'>
            clear
          </Button>
        </div>

        <div className='row g-0 justify-content-end text-end py-3 mb-2'>
          <div className='col-md-9'>By clicking the "I Agree" button, you confirm you have read the information above.</div>
        </div>

        <div className='form-group float-end'>
          <NukeRequest>Cancel Request</NukeRequest>
          <SubmitButton defaultLabel="I Agree" isSubmitting={isSubmitting} className="btn-medstar-primary ms-2" onClick={handleSubmitExemption}/>
        </div>
      </DemonTile>
    </>
  );
}
